<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование вакансии" : "Новая вакансия"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='item'
          )
        v-flex(xs12 sm6 md4)
          s-region-vacancy-picker(
            :error='errors.has("region_code")'
            :errors-messages='errors.first("region_code")'
            v-model='item.region_id'
          )
        v-flex(xs12 sm6 md4)
          s-vacancy-experiens-picker(
            :error='errors.has("experience_range")'
            :errors-messages='errors.first("experience_range")'
            v-model='item.experience_range'
          )
        v-flex(xs12 sm6 md4)
          s-vacancy-employment-form-picker(
            :error='errors.has("form_of_employment")'
            :errors-messages='errors.first("form_of_employment")'
            v-model='item.form_of_employment'
          )          
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='item.name'
            label='Название'
          )
        v-flex(xs12 sm4 md2)
          v-text-field(
            :error='errors.has("salary_min")'
            :error-messages='errors.first("salary_min")'
            :rules='[v => $rules.number(v) || "Зарплата от"]'
            v-model='item.salary_min'
            label='Зарплата от'
          )
        v-flex(xs12 sm4 md2)
          v-text-field(
            :error='errors.has("salary_max")'
            :error-messages='errors.first("salary_max")'
            :rules='[v => $rules.number(v) || "Зарплата до"]'
            v-model='item.salary_max'
            label='Зарплата до'
          )
        v-flex(xs12 sm4 md8)
          v-text-field(
            :error='errors.has("salary_comment")'
            :error-messages='errors.first("salary_comment")'
            v-model='item.salary_comment'
            label='Комментарий по ЗП'
          )   
        v-flex(xs12)
          v-textarea(
            :error='errors.has("required_files")'
            :error-messages='errors.first("required_files")'
            v-model='item.required_files'
            label='Перечислите файлы, которые нужно загрузить (каждый на новой строчке)'
          )         
        v-flex(v-if="editor" xs12)
          div(class='subheading font-weight-medium mb-3') Описание
          ckeditor(v-model='item.description')
        v-flex(v-if="editor" xs12)
          div(class='subheading font-weight-medium mb-3') Требования к кандидату
          ckeditor(v-model='item.requirements')    
        v-flex(v-if="editor" xs12)
          div(class='subheading font-weight-medium mb-3') Обязанности
          ckeditor(v-model='item.duties')
        v-flex(v-if="editor" xs12)
          div(class='subheading font-weight-medium mb-3') Преимущества при выборе кандидата
          ckeditor(v-model='item.advantages')    
        v-flex(v-if="editor" xs12)
          div(class='subheading font-weight-medium mb-3') Условия работы
          ckeditor(v-model='item.conditions')                                    

    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { createFormData } from '@/utils'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  components: {
    Ckeditor: () => import('@/components/async/Ckeditor'),
    Dropzone: () => import('@/components/async/Dropzone')
  },

  data: () => ({
    item: {},
    editor: true
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      this.item = (await this.fetchSingle({ id: this.id })).data
    },

    async onSave() {
      let data = createFormData(this.item)
      data.append('picture', this.item.picture)

      try {
        if (this.id) {
          await this.update({ id: this.id, data })
        } else {
          await this.create({ data })
        }
        this.$root.showSnack('Вакансия сохранена')
        this.$router.push({ name: 'Job.Vacancies' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('job/vacancies', [
      'fetchSingle',
      'update',
      'create',
      'removeFile',
      'sortFiles'
    ])
  },

  computed: {
    sites: {
      get() {
        let { site_ids } = this.item

        if (!site_ids) {
          return []
        }

        return site_ids.split(/,/).map(x => +x)
      },

      set(val) {
        this.item.site_ids = val.join(',')
      }
    },
    ...mapGetters('job/vacancies', ['isLoading'])
  }
}
</script>

<style>
.small textarea {
  font-size: 12px;
}
</style>
